export enum Periods {
    WEEKLY = 1,
    BIWEEKLY = 2,
    MONTHLY = 3,
}
